import {random} from "services-comun/modules/utiles/random";

const SESSION_VAR = 'cmpsession';

export class Session {
    /* STATIC */
    public static get (): Session {
        // Comprobamos si hay una sesión previa en el SessionStorage o generamos una nueva
        let sessionKey: string;
        if (sessionStorage.getItem(SESSION_VAR)) {
            sessionKey = sessionStorage.getItem(SESSION_VAR) ?? '';
        } else {
            sessionKey = random(32);
            sessionStorage.setItem(SESSION_VAR, sessionKey);
        }
        return new Session(sessionKey);
    }

    /* INSTANCE */
    private constructor(private readonly _key: string) {
    }

    public get key(): string {
        return this._key;
    }
}
